import { WithdrawIcon } from "../icons"
import { MintSquareIcon } from "../icons/huge-icons/monotone/square/mint-square"
import { StakeSquareIcon } from "../icons/huge-icons/monotone/square/stake-square"
import { UnstakeSquareIcon } from "../icons/huge-icons/monotone/square/unstake-square"
import { ComplexTab } from "../navigation/components/complex-breadcrumb-dropdown"

export const CL_FARMS_TABS: ComplexTab[] = [
  {
    id: "mint-cl-farms",
    label: "Mint CL Farms Liquidity",
    tabLabel: "Mint",
    description: "Provide liquidity for boosted rewards with liquidity automation",
    slug: "/mint",
    icon: MintSquareIcon,
  },
  {
    id: "stake-cl-farms",
    label: "Stake CL Farms Liquidity",
    tabLabel: "Stake",
    description: "Stake for boosted rewards with liquidity automation",
    slug: "/stake",
    icon: StakeSquareIcon,
  },
  {
    id: "unstake-cl-farms",
    label: "Unstake CL Farms Liquidity",
    tabLabel: "Unstake",
    description: "Unstake your liquidity from the farm",
    slug: "/unstake",
    icon: UnstakeSquareIcon,
  },
  {
    id: "redeem-cl-farms",
    label: "Redeem CL Farms Liquidity",
    tabLabel: "Redeem",
    description: "Redeem your tokens back into %s and %s",
    slug: "/redeem",
    icon: WithdrawIcon,
  },
] as const
